export default __webpack_public_path__ + "static/media/Choose4.6ac5eabf.png";